import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-more-action',
  standalone: false,
  templateUrl: './more-action.component.html',
  styleUrl: './more-action.component.css'
})
export class MoreActionComponent {
  @Input() header: string = '';
  @Output() onSkip = new EventEmitter<string>();
  onSkipAction() {
    this.onSkip.emit(); // emit data to parent
  }
}
